import React from 'react';
import Label from '~/components/Label';
import { FormattedMessage } from 'react-intl';
import ImageSet from '~/components/Gallery/ImageSet';
import { useUserFeaturedImages } from '~/modules/gallery/queries';

import styles from './GalleryPageHeader.scss';
import { useAppSelector } from '~/hooks/redux';
import { getVisibilitySettings } from '~/modules/contentVisibility';

export default function UserFeaturedImages({
  username
}: {
  username: string;
}) {
  const adultToggleState = useAppSelector(getVisibilitySettings);

  const { data, isLoading } = useUserFeaturedImages(username);

  if (data?.data.length === 0) {
    return null;
  }

  return (
    <div>
      <Label>
        <FormattedMessage id="UserFeaturedImages_Header" defaultMessage="{username}'s Featured Images" values={{ username }} />
      </Label>
      
      <ImageSet
        className={styles.GalleryPageHeader__FeaturedImageSet} 
        imageClassName={styles.GalleryPageHeader__FeaturedImagePreview} 
        noUsernames 
        adultToggleState={adultToggleState}
        images={data?.data || []}
      />
    </div>
  )
}